module.exports = __webpack_public_path__ + "static/media/YF24_5.1c0211dd.jpg";